import { createI18n } from "vue-i18n/index";
import en from "@/core/locale/en.json";
import es from "@/core/locale/es.json";
import de from "@/core/locale/de.json";
import ja from "@/core/locale/ja.json";
import fr from "@/core/locale/fr.json";

const messages = { en, es, de, ja, fr };

const i18n = createI18n({
  legacy: false,
  locale: "en",
  globalInjection: true,
  messages,
});

export default i18n;
